export default __webpack_public_path__ + "static/media/circle.fbdc8592.svg";